export default __webpack_public_path__ + "static/media/periscope-logo-transparent-white.3e8a734b.png";